export { default } from "ember-moment/helpers/is-same";
